import { DeleteTwoTone } from "@ant-design/icons";
import { Alert, notification, Popconfirm } from 'antd';
import React, { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query';
import { useDeleteCategory } from '../../../api/hooks/categories';

function DeleteCategoriesIcon({ categories }) {
   
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false);
    const queryClient = useQueryClient();

    const deleteMutation = useDeleteCategory({

        onSuccess: () => {
            closeConfirmation()
            notification.success({ message: `Categorie successfully deleted` })
            queryClient
                .invalidateQueries({ queryKey: ["listCategories"] })
                .catch(() => notification.error({ message: "Failed to reload product list" }))
        },
        onError: (e) => {
            console.error(e)
            setError(true)
        }
    })

    const onOk = () => deleteMutation.mutate(categories.category_id)
    const openConfirmation = () => setOpen(true)
    const closeConfirmation = () => {
        setError(false)
        setOpen(false)
    }
    const confirmationContents = React.useMemo(() => {
        return <>
            {`Permanently delete categorie ${categories.category_name}?`}
            {error && <Alert
                type={'error'}
                message='Failed to delete product'
                description='Please try again or contact switch support if the problem persists'
            />}
        </>
    }, [categories, error])
    return (
        <Popconfirm
            title={confirmationContents}
            open={open}
            onCancel={closeConfirmation}
            okText="Confirm"
            onConfirm={onOk}
            okButtonProps={{
                loading: deleteMutation.isLoading,
                style: { backgroundColor: "#f4900c", borderColor: "#f4900c", color: "white" }
            }}
            placement='left'
        >
            <DeleteTwoTone twoToneColor='#ff4d4f' onClick={openConfirmation} />
        </Popconfirm>
    )
}

export default DeleteCategoriesIcon
